// TODO: rewrite this type
export enum SendToModelStatusType {
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}
